'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthId$() {
  this.cbz = null;
  this.cbA = false;
  this.cbx = null;
  this.cby = false;
}
export { $c_Lpresto_types$TwoFactorAuthId$ as $c_Lpresto_types$TwoFactorAuthId$ };
$p = $c_Lpresto_types$TwoFactorAuthId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthId$;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthId$() {
}
export { $h_Lpresto_types$TwoFactorAuthId$ as $h_Lpresto_types$TwoFactorAuthId$ };
$h_Lpresto_types$TwoFactorAuthId$.prototype = $p;
$p.vb = (function() {
  if ((!this.cbA)) {
    this.cbz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j1;
    this.cbA = true;
  }
  return this.cbz;
});
$p.zg = (function() {
  if ((!this.cby)) {
    this.cbx = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().eB;
    this.cby = true;
  }
  return this.cbx;
});
var $d_Lpresto_types$TwoFactorAuthId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthId$, "presto.types$TwoFactorAuthId$", ({
  a2D: 1,
  D: 1
}));
export { $d_Lpresto_types$TwoFactorAuthId$ as $d_Lpresto_types$TwoFactorAuthId$ };
var $n_Lpresto_types$TwoFactorAuthId$;
function $m_Lpresto_types$TwoFactorAuthId$() {
  if ((!$n_Lpresto_types$TwoFactorAuthId$)) {
    $n_Lpresto_types$TwoFactorAuthId$ = new $c_Lpresto_types$TwoFactorAuthId$();
  }
  return $n_Lpresto_types$TwoFactorAuthId$;
}
export { $m_Lpresto_types$TwoFactorAuthId$ as $m_Lpresto_types$TwoFactorAuthId$ };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Id$.js.map
